export const selectPresentations = (state) => state.presentations.all || [];
export const selectCurrentPresentation = (state) =>
  state.presentations?.current || null;
export const selectIsLoading = (state) => state.presentations.isLoading;
